import { createHttpService } from '../../../../../../submodules/web-shared/services/http-service/http-service-factory';
import { LocationHttpServiceConfigurator } from './location-http-service-configurator';

export default createHttpService(
  new LocationHttpServiceConfigurator()
);
